import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Alert } from '@mui/material';
import { PageHeader, PageContent, ApprovalGroupsSettings } from '@viilutalous/common';

export default function UserGroups({ tenantId }) {
  const { t } = useTranslation();

  if (!tenantId) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="info">{t('common.no_tenant_selected')}</Alert>
      </Box>
    );
  }

  return (
    <>
      <PageHeader />
      <PageContent>
        <ApprovalGroupsSettings tenantId={tenantId} />
      </PageContent>
    </>
  );
}
